import { SvgIconProps } from "@mui/material/SvgIcon";
import FaceIcon from "./FaceIcon";

export default function FaceIconBrand(props: SvgIconProps) {
  return <FaceIcon {...props} sx={{ ...props.sx, color: "secondary.700" }} />;
}
